module.exports = __webpack_public_path__ + "img/engenious.82e302b3.png";